import { useState } from "react";
import {
  SearchOutlined,
} from "@ant-design/icons";
import { Button, Pagination } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { cardData } from "../scripts/products";
import SearchModal from "../components/modals/searchModal";

export const Catalog = () => {
  const [current, setCurrent] = useState(1);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const onChange = (page: any) => {
    setCurrent(page);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="App">
      <h2>Каталог продуктов</h2>
      <div className="tabs-group">
        <div className="flex-end">
          <p>Всего товаров: {cardData?.length}</p>
          <div className="flex-right">
            <Button type="primary" onClick={() => setModalOpen(true)}>
              <SearchOutlined /> Поиск
            </Button>
          </div>
        </div>
        <div className="catalog">
          {cardData
            .slice((current - 1) * 10, (current - 1) * 10 + 10)
            .map(({ id, images, price, title, seller }, index) => (
              <div
                className="card"
                key={index}
                onClick={() => navigate(`/product/${id}`)}
              >
                {images?.length > 0 ? (
                  images?.length > 1 ? (
                    <Slider {...settings}>
                      {images.map((img, i) => (
                        <div>
                          <img
                            src={img}
                            alt={title}
                            key={i}
                            className={"image"}
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    <img src={images[0]} alt={title} className={"image"} />
                  )
                ) : (
                  <img src={"/not-image.png"} className={"image"} />
                )}

                <div>
                  <p className="title">{price.toLocaleString("ru-RU")} ₽</p>
                  <p className="title">{title}</p>

                  <p className="sub_title">{seller}</p>
                </div>
              </div>
            ))}
        </div>
        <Pagination
          onChange={onChange}
          current={current}
          total={cardData?.length}
          pageSize={10}
        />
      </div>
      <SearchModal open={modalOpen} isCloseModal={closeModal} />
    </div>
  );
};
